// Live's preview header (`AssetInfoHeader`, captures design-ref/enlarge-25 01 and 08): the
// maker's avatar, their name over the day, and no title. Live's actor and product previews show
// it; ours, the shared lightbox's `header` (issue 828, bug 25).
import { Avatar, Group, Stack, Text } from "@mantine/core";

import { formatDay } from "../../ui/format";
import classes from "./MediaPreview.module.css";

export function PreviewMaker({ name, at }: { name: string; at: string }) {
  return (
    <Group gap={12} wrap="nowrap">
      <Avatar size={40} radius="xl" name={name} color="indigo" />
      <Stack gap={0}>
        <Text className={classes.maker}>{name}</Text>
        <Text className={classes.day}>{formatDay(at)}</Text>
      </Stack>
    </Group>
  );
}
